export default function converterStringParaDate(dataString) {
    // Divide a string da data em partes: dia, mês e ano 
    let partes = dataString.split('/');
    let dia = parseInt(partes[0], 10);
    let mes = parseInt(partes[1], 10) - 1; // Subtrai 1 porque os meses no objeto Date começam do zero 
    let ano = parseInt(partes[2], 10); // Cria um novo objeto Date com os valores obtidos 

    let novaData = new Date(ano, mes, dia);

    return novaData;
}